import ActionTypes from "../../../../constants/ActionTypes";
import { IOrderState } from "./types";

const initialState: IOrderState = {
  cartConflictData: [],
  resolvingInProgress: false
};

const orderReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.ORDER.SET_CART_CONFLICT_DATA:
    return {
      ...state,
      cartConflictData: action.payload
    };
  case ActionTypes.ORDER.SET_RESOLVING_IN_PROGRESS:
    return {
      ...state,
      resolvingInProgress: action.payload
    };
  }
  return state;
};

export default orderReducer;
